const styles = {
  lottie: {
    width: '60%'
  }
}

export default styles
